import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, Params } from "@angular/router";
import { ChangePasswordRequest } from "./change-password-request";
import { AdminService } from "../../service/admin.service";
import { UtilService } from "../../service/util.service";
import * as constants from '../../app.constants';

declare let $: any;

@Component({
    selector: 'change-password',
    template: require('./change-password.component.html'),
    styles: [require('./change-password.component.css')]
})
export class ChangePasswordComponent implements OnInit, AfterViewInit {

    model: ChangePasswordRequest;
    errorMsg: string;
    successMsg: string;

    constructor(
        private router: Router,
        private adminService: AdminService)
    {
        this.model = new ChangePasswordRequest();
        // this.successMsg = "Your password has been changed successfully.";
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        $("#password").focus();
    }

    changePassword(): void {
        console.log('ChangePassword form submitted.');
        console.debug(JSON.stringify(this.model));
        this.errorMsg = null;
        if (!this.model.password || this.model.password.length < constants.MIN_PWD_LENGTH) {
            this.errorMsg = constants.messages.invalidPass;
        } else if (!this.model.confirmPassword || this.model.confirmPassword.length < constants.MIN_PWD_LENGTH) {
            this.errorMsg = constants.messages.invalidConfirmPass;
        } else if (this.model.password !== this.model.confirmPassword) {
            this.errorMsg = constants.messages.notMatchPass;
        }  else {
            this.model.newPassword = this.model.password;
            // Delete non required attributes
            delete this.model['password'];
            delete this.model['confirmPassword'];

            console.debug(JSON.stringify(this.model));

            this.adminService
                .postCall(constants.URLs.changePassword, this.model, true)
                .then(res => {
                    console.log('res');
                    console.log(res);
                    if (res.status == 1 && res.response && res.response.message) {
                        this.successMsg = res.response.message;
                    } else if (res.error && res.error.errors && res.error.errors.length) {
                        this.errorMsg = res.error.errors[0].message;
                    } else {
                        this.errorMsg = res.error.message;
                    }
                })
                .catch((error: any) => {
                    console.error('ChangePasswordComponent- an error occurred', error);
                    this.errorMsg = error.message? error.message: constants.messages.serverError;
                });
        }
    }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/change-password/change-password.component.ts